import React from 'react';
import { Checkbox, Spin, Tooltip, Typography } from 'antd';
import SearchInput from '@/components/SearchInput';
import type { ActivityUserLite } from '@/apis/activity';

const { Text } = Typography;

interface UsersFilterDropdownProps {
  /** Already server-searched/paginated by the parent — rendered as-is. */
  users?: ActivityUserLite[];
  isUserSelected?: (id: string) => boolean;
  onToggleUser?: (id: string, checked: boolean) => void;
  allSelected?: boolean;
  onToggleAll?: (checked: boolean) => void;
  search?: string;
  onSearchChange?: (value: string) => void;
  hasMore?: boolean;
  onPopupScroll?: (e: React.UIEvent<HTMLDivElement>) => void;
}

const UsersFilterDropdown: React.FC<UsersFilterDropdownProps> = ({
  users,
  isUserSelected,
  onToggleUser,
  allSelected,
  onToggleAll,
  search,
  onSearchChange,
  hasMore,
  onPopupScroll,
}) => {
  return (
    <div
      className='activity-feed-dropdown-card activity-users-dropdown'
      onClick={(e) => e.stopPropagation()}
    >
      <SearchInput
        placeholder='Search users'
        width='100%'
        defaultValue={search}
        onChange={onSearchChange}
        onClear={() => onSearchChange('')}
      />
      <div className='activity-feed-dropdown-list' onScroll={onPopupScroll}>
        <div className='activity-feed-dropdown-item'>
          <Checkbox
            className='checkbox-sm'
            checked={allSelected}
            onChange={(e) => onToggleAll(e.target.checked)}
          >
            All users
          </Checkbox>
        </div>
        {users.map((user) => {
          const isPending = user?.type === 'No activity';
          const tag = user?.type !== 'Active' ? user?.type : null;
          const row = (
            <div
              key={user?.id}
              className={`activity-feed-dropdown-item ${isPending ? 'is-muted' : ''}`}
            >
              <Checkbox
                className='checkbox-sm'
                checked={!isPending && isUserSelected(user?.id)}
                disabled={isPending}
                onChange={(e) => onToggleUser(user?.id, e.target.checked)}
              >
                <Text
                  ellipsis={{ tooltip: user?.name }}
                  style={{ maxWidth: '100%', fontSize: 12, color: 'inherit' }}
                >
                  {user?.name}
                </Text>
              </Checkbox>
              {tag && (
                <span className='activity-feed-dropdown-item-tag'>{tag}</span>
              )}
            </div>
          );
          return isPending ? (
            <Tooltip
              key={user?.id}
              title='Invited but never logged in'
              placement='left'
            >
              {row}
            </Tooltip>
          ) : (
            row
          );
        })}
        {hasMore && (
          <div className='activity-feed-dropdown-item activity-feed-load-more-hint'>
            <Spin size='small' />
          </div>
        )}
      </div>
    </div>
  );
};

export default UsersFilterDropdown;
